<template>
    <div class="row">
        <div class="col-lg-4 col-md-6 wow move-up">
            <div class="clinic-grid mb-30">
                <div class="ht-clinic-service-box">
                    <router-link to="">
                        <span class="content-header">
                            <div class="icon">
                                <i class="fal fa-paper-plane"></i>
                            </div>
                            <h5 class="heading">{{ $t('title1') }}</h5>
                        </span>
                        <div class="content-body">
                            <div class="service_text">{{ $t('detail1') }}</div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 wow move-up">
            <div class="clinic-grid mb-30">
                <div class="ht-clinic-service-box">
                    <router-link to="">
                        <span class="content-header">
                            <div class="icon">
                                <i class="fal fal fa-bolt"></i>
                            </div>
                            <h5 class="heading">{{ $t('title2') }}</h5>
                        </span>
                        <div class="content-body">
                            <div class="service_text">{{ $t('detail2') }}</div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 wow move-up">
            <div class="clinic-grid mb-30">
                <div class="ht-clinic-service-box">
                    <router-link to="">
                        <span class="content-header">
                            <div class="icon">
                                <i class="fal fa-chart-line"></i>
                            </div>
                            <h5 class="heading">{{ $t('title3') }}</h5>
                        </span>
                        <div class="content-body">
                            <div class="service_text">{{ $t('detail3') }}</div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 wow move-up">
            <div class="clinic-grid mb-30">
                <div class="ht-clinic-service-box">
                    <router-link to="">
                        <span class="content-header">
                            <div class="icon">
                                <i class="fal fa-stopwatch"></i>
                            </div>
                            <h5 class="heading">{{ $t('title4') }}</h5>
                        </span>
                        <div class="content-body">
                            <div class="service_text">{{ $t('detail4') }}</div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 wow move-up">
            <div class="clinic-grid mb-30">
                <div class="ht-clinic-service-box">
                    <router-link to="">
                        <span class="content-header">
                            <div class="icon">
                                <i class="fal fa-street-view"></i>
                            </div>
                            <h5 class="heading">{{ $t('title5') }}</h5>
                        </span>
                        <div class="content-body">
                            <div class="service_text">{{ $t('detail5') }}</div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 wow move-up">
            <div class="clinic-grid mb-30">
                <div class="ht-clinic-service-box">
                    <router-link to="">
                        <span class="content-header">
                            <div class="icon">
                                <i class="fal fa-users"></i>
                            </div>
                            <h5 class="heading">{{ $t('title6') }}</h5>
                        </span>
                        <div class="content-body">
                            <div class="service_text">{{ $t('detail6') }}</div>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ClinicFeature',
    }
</script>


<i18n>
{
  "en": {
    "title1": "Move away from paper diaries",
    "detail1": "Dyjest App empowers patients to track their own progress between appointments.",
    "title2": "View reliable stats instantly",
    "detail2": "Pull up precise, at-a-glance counts of recent seizures, medication compliance and more.",
    "title3": "Use data to track progress",
    "detail3": "Monitor the impact of treatment plans over time and spot any patterns.",
    "title4": "Save time on every appointment",
    "detail4": "Less admin means more time to focus on improved discussions with your patients.",
    "title5": "A quick, clear view of every patient",
    "detail5": "View smart data analytics for each patient, in a highly intuitive visual interface.",
    "title6": "Collaborate with your colleagues",
    "detail6": "Share responsibilities and learnings for a more holistic approach to each case."
  },
  "fr": {
    "title1" : "Abandonnez les journaux papier",
    "detail1" : "L'appli Dyjest permet aux patients de suivre eux-mêmes leurs progrès entre deux rendez-vous",
    "title2" : "Visualisez instantanément des statistiques fiables",
    "detail2" : "Tirez des comptes précis, en un clin d'œil, des crises récentes, de l'observance des médicaments et plus encore.",
    "title3" : "Utilisez les données pour suivre les progrès",
    "detail3" : "Surveillez l'impact des plans de traitement au fil du temps et repérez toute tendance.",
    "title4" : "Gagnez du temps à chaque rendez-vous",
    "detail4" : "Moins d'administration signifie plus de temps pour se concentrer sur des discussions améliorées avec vos patients",
    "title5" : "Une vue rapide et claire de chaque patient",
    "detail5" : "Visualisez des analyses de données intelligentes pour chaque patient, dans une interface visuelle très intuitive.",
    "title6" : "Collaborez avec vos collègues",
    "detail6" : "Partagez les responsabilités et les apprentissages pour une approche plus holistique de chaque cas."
  }
}
</i18n>